
export default {
  name: 'ProductDescriptionItem',
  props: {
    index: Number,
    description: Object,
    product: Object,
  },
}
